// extracted by mini-css-extract-plugin
module.exports = {"input":"_2MVFLX6-M4rZkNsOb6N0Px","select":"DvsFwO4kTfS0TTPCdr7eM","checkbox":"_3IhrjizKVNxaLpWC5mLTGo"};